import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Dayjs } from "dayjs";
import { dateTimeConversionService } from "../../../shared/services/DateTimeConversionService";

export interface ExpirationSelectorProps {
    expirations: string[];
    value: string;
    onValueChange: (newValue: string) => void;
    disabled?: boolean;
}

export function ExpirationSelector({
    expirations,
    value,
    onValueChange,
    disabled,
}: ExpirationSelectorProps) {
    return (
        <FormControl
            variant="standard"
            size="small"
            sx={{ width: 180 }}
            disabled={disabled}
        >
            <InputLabel id="expiration-label">
                <b>Expirations</b> {getSelectControlLabelExtension(expirations)}
            </InputLabel>
            <Select
                labelId="expiration-asset-label"
                value={
                    value
                        ? dateTimeConversionService.parseAndConvertDateToLongFormattedString(value)
                        : ' '
                }
                onChange={(eventArg: SelectChangeEvent<string>) => onValueChange(eventArg.target.value)}
                sx={{
                    "& .MuiInputBase-input": {
                        paddingBottom: '2px',
                    },
                }}
                {...(expirations.length === 0
                    ? { disabled: true }
                    : {})}
            >
                {expirations.map((expiration) => (
                        <MenuItem
                            key={dateTimeConversionService.parseAndConvertDateToLongFormattedString(expiration)}
                            value={dateTimeConversionService.parseAndConvertDateToLongFormattedString(expiration)}
                        >
                            {getSelectControlMenuItemValue(dateTimeConversionService.parseToUtcDateJs(expiration))}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
}

function getSelectControlLabelExtension(expirations: string[]): string | null {
    return expirations.length > 0
        ? `(${expirations.length} available)`
        : null;
}

function getSelectControlMenuItemValue(expirationDate: Dayjs): string {
    return expirationDate.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours') < 48
        ? `${expirationDate.format("DD.MMM.YYYY")} - ${expirationDate.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours')} h`
        : `${expirationDate.format("DD.MMM.YYYY")} - ${expirationDate.diff(dateTimeConversionService.getCurrentUtcDate(), 'days')} d`;
}
